import AppLayout from "./layout/AppLayout";
import Login from "./pages/Login";
import { createTheme, ThemeProvider } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      light: "#5393ff",
      // main: "#2979ff",
      main: "#1D589D",
      dark: "#1c54b2",
      // contrastText: '#000',
      link: "#1c54b2",
    },
    secondary: {
      light: "#ed4b82",
      // main: "#e91e63",
      main: "#DC4646",
      dark: "#a31545",
      contrastText: "#fff",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // borderRadius: '12px',
          fontSize: "14px",
          // fontWeight: 'bolder',
          minWidth: 0,
        },
      },
    },
  },
});

function App() {
  const login = JSON.parse(sessionStorage.getItem("authUserData"))?.login;
  const userData = JSON.parse(sessionStorage.getItem("authUserData"));
  const userRole = JSON.parse(sessionStorage.getItem("authUserRole"));

  return (
    <div>
      <ThemeProvider theme={theme}>
        {userData && userRole && login ? <AppLayout /> : <Login />}
      </ThemeProvider>
    </div>
  );
}

export default App;
